<template>
  <main>
    <div class="container mx-auto my-6 sm:px-4">
      <MainContent
        paddingClass="md:pt-28 md:pb-52 md:px-[4.8rem] sm:px-[1.0rem] sm:pb-[5.0rem] sm:pt-[13.5rem]"
      >
        <div class="p-6">
          <h2
            class="text-black text-[18px] sm:text-[1.8rem] md:text-[2.6rem] font-semibold leading-[1.15] tracking-[-0.78px]"
          >
            {{ $t("Knowledge is better when is shared") }}
          </h2>
          <!-- <p class="text-black text-[1.6rem] font-medium pt-[1.6rem]">
            {{ $t("Know more about any topic about healthcare") }}
          </p> -->
        </div>
        <div>
          <!-- <h3
            class="text-[color:var(--black)] text-[1.8rem] font-semibold pb-[2.4rem]"
          >
            {{ $t("All articles") }}
          </h3> -->
          <TopThisWeek
            class="md:pt-10 sm:pt-[3.0rem]"
            :articles="popularPosts"
          />

          <XAllArticles
            class="md:pb-[12rem] sm:mt-14"
            :articlesData="allPosts"
            :category="$t('Recent articles')"
            :viewAll="false"
          />

          <!-- <CategoryPosts
      v-for="(category, index) in categories"
      :key="category.title"
      :posts="category.posts"
      :categoryTitle="category.title"
      :class="{ 'md:pb-[12rem]': index !== categories.length - 1 }"
    /> -->

          <div
            class="pagination-controls text-center my-12"
            v-if="totalCount > pageSize"
          >
            <button
              @click="previousPage"
              :disabled="firstRecord === 0"
              class="px-4 py-2 mx-2 bg-gray-200 rounded disabled:opacity-50"
            >
              {{ $t("Previous") }}
            </button>
            <span>
              {{
                $t("Page {current} of {total}", {
                  current: currentPage,
                  total: totalPages,
                })
              }}
            </span>
            <button
              @click="nextPage"
              :disabled="lastRecord >= totalCount"
              class="px-4 py-2 mx-2 bg-gray-200 rounded disabled:opacity-50"
            >
              {{ $t("Next") }}
            </button>
          </div>
        </div>
      </MainContent>
    </div>
  </main>
</template>

<script>
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import { useSeo } from "@/composables/useSeo";
// import CategoryPosts from "@/components/blog/categoryPosts.vue";
import TopThisWeek from "@/components/blog/topThisWeek.vue";
import XAllArticles from "@/components/blog/xAllArticles.vue";
import MainContent from "@/components/design/mainContent.vue";
import { blogService } from "@/services/blogService";
import { config } from "@/services/configService.ts";

import drImage from "@/assets/images/articles-dr-enrique.png";
import blogFallback from "@/assets/images/articles-bannar-image1.png";

export default defineComponent({
  name: "ArticlesView",
  setup() {
    const { t } = useI18n();
    useSeo({ title: t("seoBlogTitle"), description: t("seoBlogDesc") });
  },
  components: {
    // CategoryPosts,
    TopThisWeek,
    XAllArticles,
    MainContent,
  },
  data() {
    return {
      popularPosts: [],
      allPosts: [],
      totalCount: 0,
      firstRecord: 0,
      pageSize: 5,
    };
  },
  computed: {
    footerMenus() {
      return [
        [
          { text: this.$t("Psychologist"), link: "#" },
          { text: this.$t("Gynecologist"), link: "#" },
          { text: this.$t("Traumatologist"), link: "#" },
          { text: this.$t("Dermatologist"), link: "#" },
          { text: this.$t("Psychiatrist"), link: "#" },
          { text: this.$t("Dentist"), link: "#" },
          { text: this.$t("General practitioner"), link: "#" },
          { text: this.$t("Otolaryngologist"), link: "#" },
          { text: this.$t("Ophthalmologist"), link: "#" },
          { text: this.$t("Urologist"), link: "#" },
          { text: this.$t("Podiatrist"), link: "#" },
          { text: this.$t("Allergist"), link: "#" },
        ],
      ];
    },
    lastRecord() {
      return this.firstRecord + this.pageSize;
    },
    currentPage() {
      return Math.floor(this.firstRecord / this.pageSize) + 1;
    },
    totalPages() {
      return Math.ceil(this.totalCount / this.pageSize);
    },
  },
  async mounted() {
    await this.loadPopularPosts();
    await this.loadAllPosts();
  },
  methods: {
    async loadPopularPosts() {
      const apiPosts = await blogService.getPopularPosts();
      if (!apiPosts || apiPosts.length === 0) {
        this.popularPosts = this.getFallbackPosts().map((post) =>
          this.mapPostData(post),
        );
        return;
      }
      this.popularPosts = apiPosts.map((post) => this.mapPostData(post));
    },

    async loadAllPosts() {
      const apiResponse = await blogService.getPostsByPage(
        this.firstRecord,
        this.lastRecord,
      );
      if (apiResponse && apiResponse.ok && apiResponse.data?.length) {
        this.totalCount = apiResponse.totalCount;
        this.allPosts = apiResponse.data.map((post) => this.mapPostData(post));
        return;
      }
      const fallbackPosts = this.getFallbackPosts();
      this.totalCount = fallbackPosts.length;
      this.allPosts = fallbackPosts.map((post) => this.mapPostData(post));
    },

    mapPostData(post) {
      return {
        id: post.id,
        title: post.title,
        authorName: post.name || this.$t("Medkus Team"),
        authorImage: drImage,
        image: `${config.host}${config.uploads}${post.image}`,
        alt: this.$t("Cover image for {postTitle}", { postTitle: post.title }),
        category: post.category || "blog",
      };
    },

    getFallbackPosts() {
      return [
        {
          id: "blog-fallback-1",
          title: this.$t("Content temporarily unavailable"),
          name: this.$t("Medkus Team"),
          image: blogFallback,
          smalText: this.$t(
            "We are updating our articles. Please try again in a few minutes.",
          ),
          text: this.$t(
            "We are restoring the connection to the blog so you can continue discovering functionalhealth resources. Thank you for your patience.",
          ),
        },
      ];
    },

    async nextPage() {
      if (this.lastRecord < this.totalCount) {
        this.firstRecord += this.pageSize;
        await this.loadAllPosts();
      }
    },
    async previousPage() {
      if (this.firstRecord > 0) {
        this.firstRecord -= this.pageSize;
        await this.loadAllPosts();
      }
    },
  },
});
</script>

<style>
.knowledge_better_box {
  background: linear-gradient(
    269deg,
    rgba(0, 0, 0, 0) 12.85%,
    rgba(255, 255, 255, 0.2) 60.5%
  );
}
</style>
